export default __webpack_public_path__ + "assets/models/7a1f6e5af6d5acfec21d7f9aed2cbe07.glb";